<div class="mt-5">
  <canvas id="service-line-chart5" width="502" height="170"></canvas>
</div>
